import { FormControl, FormErrorMessage, Input } from "@chakra-ui/react";
import type { AddressDraft } from "../addresses.types";

export function AddressInput(props: {
  address: AddressDraft;
  isDisabled?: boolean;
  isInvalid?: boolean;
  minW?: string;
  onChange: (address: string) => void;
}) {
  return (
    <FormControl isRequired isInvalid={props.isInvalid}>
      <Input
        aria-label="Address"
        isDisabled={props.isDisabled}
        minW={props.minW}
        placeholder="Address"
        value={props.address.address}
        onChange={(event) => props.onChange(event.target.value)}
      />
      <FormErrorMessage>Address is required.</FormErrorMessage>
    </FormControl>
  );
}
